import { Fragment } from "react";
import PropTypes from "prop-types";
import NormalOrderListItem from "./NormalOrderListItem/NormalOrderListItem";
import classes from "./NormalOrdersList.module.css";

const NormalOrdersList = (props) => {
  const { orders } = props;
  return (
    <ul className={classes["normal-orders-list"]}>
      {orders.map((order, index) => (
        <Fragment key={index}>
          <NormalOrderListItem order={order} />
          {orders.length - 1 !== index && (
            <li className={classes["normal-orders-list__item-separator"]} />
          )}
        </Fragment>
      ))}
    </ul>
  );
};

export default NormalOrdersList;

NormalOrdersList.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object),
};
